import { render, staticRenderFns } from "./BookingPositionRejectedList.vue?vue&type=template&id=593b7e40&"
import script from "./BookingPositionRejectedList.vue?vue&type=script&lang=js&"
export * from "./BookingPositionRejectedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports